import style from "./GameFieldOffCanvasTimer.module.css"
import { useStopwatch } from 'react-timer-hook';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import NotStartedOutlinedIcon from '@mui/icons-material/NotStartedOutlined';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {useEffect, useState} from "react";
import * as GameService from "../api/GameService";

export default function GameFieldOffCanvasTimer(props) {
    const [folded, setFolded] = useState(true)
    const [timerUnsaved, setTimerUnsaved] = useState(false)

    const {
        totalSeconds,
        milliseconds,
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        reset,
    } = useStopwatch({ autoStart: false, interval: 1000 });

    useEffect(
        () => {
                GameService.getTimer(
                    props.game_id,
                    (response) => {
                        const stopwatchOffset = new Date();
                        const currentStr = localStorage.getItem("timer-" + props.game_id)
                        const current = currentStr ? parseInt(currentStr) : 0
                        stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + Math.max(response.total_seconds, current))
                        reset(stopwatchOffset, response.state === "active")
                    },
                    () => {}
                )
        }, [isRunning]
    )

    useEffect(() => {
        const currentStr = localStorage.getItem("timer-" + props.game_id)
        const current = currentStr ? parseInt(currentStr) : 0
        localStorage.setItem("timer-"+props.game_id, Math.max(totalSeconds, current))
    }, [totalSeconds])


    function pauseTimer() {
        setTimerUnsaved(false)
        GameService.getTimer(
            props.game_id,
            (response) => {
                GameService.postTimerUpdate(
                    props.game_id,
                    Math.max(totalSeconds - response.total_seconds, 0),
                    "pause",
                    () => {},
                    () => {}
                )
                pause()
            },
            () => {}
        )
    }

    function startTimer() {
        GameService.postTimerUpdate(
            props.game_id,
            0,
            "start",
            () => {},
            () => {}
        )
        start()
    }

    function clearTimer() {
        GameService.getTimer(
            props.game_id,
            (response) => {
                GameService.postTimerUpdate(
                    props.game_id,
                    0 - response.total_seconds,
                    "pause",
                    () => {},
                    () => {}
                )
                localStorage.setItem("timer-"+props.game_id, 0)
                reset()
                localStorage.setItem("timer-"+props.game_id, 0)
            },
            () => {}
        )
    }


    return (
        <div className={folded ? style.containerFolded : style.containerUnfolded} style={timerUnsaved ? {backgroundColor: "red"} : {}}>
            {!folded && <>
                <div style={{fontSize: '14px', fontWeight:"bold", width: '80px'}}>
                    <span>{hours > 9 ? hours : "0"+hours}</span>:<span>{minutes > 9 ? minutes : "0" + minutes}</span>:<span>{seconds > 9 ? seconds : "0" + seconds}</span>
                </div>
                {isRunning ? <NotStartedIcon onClick={() => pauseTimer()}/> : <NotStartedOutlinedIcon onClick={() =>startTimer()}/>}
                <div>
                    <CancelOutlinedIcon style={isRunning ? {display: "none"} : {}} onClick={clearTimer}/>
                </div>

            </>}

            <TimerOutlinedIcon onClick={() => setFolded(!folded)}></TimerOutlinedIcon>
        </div>
    );
}